var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { transition: "dialog-bottom-transition", "max-width": "600" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  { attrs: { small: "", color: "indigo", outlined: "" } },
                  on
                ),
                [_vm._v("\n      変更\n    ")]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      [
        _c(
          "v-card",
          [
            _c("v-toolbar", { attrs: { color: "primary", dark: "" } }, [
              _vm._v("トラッキング時間変更"),
            ]),
            _vm._v(" "),
            _c("v-card-text", [
              _c(
                "div",
                { staticClass: "text-h2 p-12" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.numberRules,
                      label: "時間",
                      type: "number",
                      required: "",
                    },
                    model: {
                      value: _vm.hours,
                      callback: function ($$v) {
                        _vm.hours = $$v
                      },
                      expression: "hours",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.numberRules,
                      label: "分",
                      type: "number",
                      required: "",
                    },
                    model: {
                      value: _vm.minutes,
                      callback: function ($$v) {
                        _vm.minutes = $$v
                      },
                      expression: "minutes",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "v-card-actions",
              { staticClass: "justify-end" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { depressed: "", color: "primary" },
                    on: { click: _vm.onUpdate },
                  },
                  [_vm._v("\n          更新\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }